module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.preference === 'mmoll') ? _c('mu-text-field', {
    attrs: {
      "label": _vm.$t('message.cardBloodGlucose'),
      "type": "number",
      "step": "any",
      "helpText": "mmol/L",
      "underlineShow": "",
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.blood_glucose_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.reading, "blood_glucose_mmoll", _vm._n($$v))
      },
      expression: "reading.blood_glucose_mmoll"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.preference === 'mgdl') ? _c('mu-text-field', {
    attrs: {
      "label": _vm.$t('message.cardBloodGlucose'),
      "type": "number",
      "step": "any",
      "helpText": "mg/dL",
      "underlineShow": "",
      "fullWidth": ""
    },
    model: {
      value: (_vm.reading.blood_glucose_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.reading, "blood_glucose_mgdl", _vm._n($$v))
      },
      expression: "reading.blood_glucose_mgdl"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tags) ? _c('mu-select-field', {
    attrs: {
      "hintText": _vm.$t('message.selectText'),
      "multiple": "",
      "label": _vm.$t('message.labelTagYourReading'),
      "fullWidth": true,
      "maxHeight": 300,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.readingTags),
      callback: function($$v) {
        _vm.readingTags = $$v
      },
      expression: "readingTags"
    }
  }, _vm._l((_vm.listTags), function(tag, index) {
    return _c('mu-menu-item', {
      key: 'reading-tag-' + index,
      attrs: {
        "value": tag.tag_id,
        "title": _vm.$t(_vm.localizeTag(tag.tag))
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6283a4ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Edit/BloodGlucose/BloodGlucoseEdit.vue
// module id = 3751
// module chunks = 1